import React, {useEffect, useState } from 'react';
import {CONNECTOR_DETAILS, CONNECTOR_NAME, CONSUME_ENDPOINT } from '../ISRConstants';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../Pages/DefineModel/model';
import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';

type TConnectorComponentProps = {
    selectedItem: TField | TSubmodel | TProductCategory | TConnector |  null;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo: TIndexState;
}

const ConnectorComponent = ({selectedItem, setUserProjectDataModels, userProjectDataModels, indexInfo}: TConnectorComponentProps) => {
    const [fieldName, setFieldName] = useState<string>('');
    const [consumeTarget, setConsumeTarget] = useState<boolean>(true);

    useEffect(() => {
        const connector = selectedItem as TConnector;
        if (connector?.data?.belongsToDataModel ?? false) {
            setFieldName(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data.connectors[indexInfo?.connectorIndex ?? -1].data?.name ?? "");
            setConsumeTarget(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data.connectors[indexInfo?.connectorIndex ?? -1].data?.isConsumable ?? true);
        } else {
            setFieldName(userProjectDataModels?.project.connectors[indexInfo?.connectorOutsideDataModelIndex ?? -1]?.data?.name ?? "");
            setConsumeTarget(userProjectDataModels?.project.connectors[indexInfo?.connectorOutsideDataModelIndex ?? -1]?.data?.isConsumable ?? true);
        }
    }, [selectedItem]);

    const handleConnectorNameChange = (value: string) => {
        setFieldName(value);
        updateFieldName(value);
    };

    const handleConsumeTargeChange = (value: boolean) => {
        setConsumeTarget(value);
        updateConsumeTarget(value);
    }

    const updateFieldName = (fieldName: string) => {
        const connector = selectedItem as TConnector;
        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };
            if (connector && connector?.data && connector?.data?.belongsToDataModel) {
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.connectors[indexInfo?.connectorIndex ?? -1]) {
                    dataModelToUpdate.data.connectors[indexInfo.connectorIndex ?? -1].data.name = fieldName;
                }
            } else {
                const fieldToUpdate = newDataModels.project.connectors[indexInfo?.connectorOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data) {
                    fieldToUpdate.data.name = fieldName;
                }
            }
        return newDataModels;});
    };

    const updateConsumeTarget = (value: boolean) => {
        const connector = selectedItem as TConnector;
        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };
            if (connector && connector?.data && connector?.data?.belongsToDataModel) {
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.connectors[indexInfo?.connectorIndex ?? -1]) {
                    dataModelToUpdate.data.connectors[indexInfo.connectorIndex ?? -1].data.isConsumable = value;
                }
            } else {
                const fieldToUpdate = newDataModels.project.connectors[indexInfo?.connectorOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data) {
                    fieldToUpdate.data.isConsumable = value;
                }
            }
        return newDataModels;});
    };

    return (
        <div className='cart-style-dm'>
            <label className='cart-title'>{CONNECTOR_DETAILS}</label>
            <div className='tw-flex tw-items-center tw-mt-3'>
                <div className='tw-w-[60%] tw-pe-2'>
                    <label className='tw-text-sm tw-text-[#747593] tw-block'>{CONNECTOR_NAME}</label>
                    <input 
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        value={fieldName}
                        onChange={(e) => handleConnectorNameChange(e.target.value)}
                        placeholder={CONNECTOR_NAME} />
                </div>
                <div className='tw-w-[60%] tw-ms-3'>
                    <label className='tw-text-sm tw-text-[#747593] tw-block tw-mb-2'>{CONSUME_ENDPOINT}</label>
                    <ToggleButton
                            name={CONSUME_ENDPOINT} 
                            value={consumeTarget} 
                            onChange = {(e) => handleConsumeTargeChange(e.target.checked)} />
                </div>
                
            </div>
        </div>
    );
}

export default ConnectorComponent;